<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">

  <div class="  no-field-space timeframe-matching    selection" [formGroup]="strcutureSelectionFormGroup">

    <sc-flex>
      <mat-form-field appearance="fill">
        <mat-label>{{'Von'| translate:['tmc-yard.ui.timeframe-matching.from-date',
          translationService.language]}}</mat-label>
        <input matInput formControlName="dateFrom" [matDatepicker]="picker1" type="date-local">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
      <sc-content-spacer></sc-content-spacer>
      <mat-form-field appearance="fill">
        <mat-label>{{'Bis'| translate:['tmc-yard.ui.timeframe-matching.to-date', translationService.language]}}
        </mat-label>
        <input matInput formControlName="dateUntil" [matDatepicker]="picker2" type="date-local">
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
      <sc-content-spacer></sc-content-spacer>
      <mat-form-field appearance="fill" class="structure-selection">
        <mat-label>
          {{'structure node' | translate: ['tmc.timeframe-usage.structure.node',
          translationService.language]}}
        </mat-label>
        <mat-select name="structureNode" formControlName="structureNode">
          <mat-option *ngFor="let o of structureNodes" [value]="o">
            <ng-container *ngIf="o.stationGroupId == null && o.stationSetId != null">
              &nbsp;&nbsp;
            </ng-container>
            {{o.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button (click)="updateData()" [disabled]="!strcutureSelectionFormGroup.valid">
        {{'update'| translate:['reporting.timeframe-matching.action-update-now',
        translationService.language]}}
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button (click)="createExcel()" [disabled]="isCreateDisabled()" mat-flat-button
        class="spaceBehind">{{'export'|
        translate:['reporting.list-export.action.export',
        translationService.language]}}</button>
    </sc-flex>
  </div>

  <sc-content-spacer [vertical]="true"></sc-content-spacer>

  <div class="carrier-filter">
    <span class="item action" (click)="resetCarrierSelection()" *ngIf="selectedCarrier">
      <sc-icon iconClass="fa-chevron-left"></sc-icon>
    </span>
    {{selectedCarrier}}
  </div>

  <sc-content-spacer [vertical]="true" *ngIf="selectedCarrier"></sc-content-spacer>

  <div class="results-summary">
    <sc-flex [stretchContent]="true">
      <div class="title">{{'Summary'| translate:['reporting.timeframe-matching.summary', translationService.language]}}
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">{{'Transports'| translate:['reporting.timeframe-matching.transports',
          translationService.language]}}</div>
        <div class="value-count">{{sumRow?.totalTransports}}</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">{{'With Time Slot'| translate:['reporting.timeframe-matching.withTimeSlot',
          translationService.language]}}</div>
        <div class="value-count">{{sumRow?.withTimeslotBooking}}</div>
        <div class="value-percentage">{{sumRow?.percentageWithTimeslotBooking | number: '1.1-1'}} %</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">{{'Early'| translate:['reporting.timeframe-matching.early', translationService.language]}}
        </div>
        <div class="value-count">{{sumRow?.countEarly}}</div>
        <div class="value-percentage">{{sumRow?.percentageEarly | number: '1.1-1'}} %</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">{{'In time'| translate:['reporting.timeframe-matching.inTime',
          translationService.language]}}</div>
        <div class="value-count">{{sumRow?.countInTime}}</div>
        <div class="value-percentage">{{sumRow?.percentageInTime | number: '1.1-1'}} %</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">{{'Delayed'| translate:['reporting.timeframe-matching.delayed',
          translationService.language]}}</div>
        <div class="value-count">{{sumRow?.countDelayed}}</div>
        <div class="value-percentage">{{sumRow?.percentageDelayed | number: '1.1-1'}} %</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">{{'Late'| translate:['reporting.timeframe-matching.late', translationService.language]}}
        </div>
        <div class="value-count">{{sumRow?.countLate}}</div>
        <div class="value-percentage">{{sumRow?.percentageLate | number: '1.1-1'}} %</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">{{'Not arrived'| translate:['reporting.timeframe-matching.notArrived',
          translationService.language]}}</div>
        <div class="value-count">{{sumRow?.countNotArrived}}</div>
        <div class="value-percentage">{{sumRow?.percentageNotArrived | number: '1.1-1'}} %</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">{{'not yet arrived'| translate:['reporting.timeframe-matching.notYetArrived',
          translationService.language]}}</div>
        <div class="value-count">{{sumRow?.countNotYetArrived}}</div>
        <div class="value-percentage">{{sumRow?.percentageNotYetArrived | number: '1.1-1'}} %</div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="summary-value">
        <div class="caption">{{'Other'| translate:['reporting.timeframe-matching.other', translationService.language]}}
        </div>
        <div class="value-count">{{sumRow?.countOther}}</div>
        <div class="value-percentage">{{sumRow?.percentageOther | number: '1.1-1'}} %</div>
      </div>
    </sc-flex>
  </div>

  <sc-content-spacer [vertical]="true"></sc-content-spacer>

  <sc-flex-fitting-content [vertical]="true">
    <sc-content-area [fitHeight]="true">
      <sc-scroll-pane>

        <table mat-table [dataSource]="dataSource">

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>
              {{'Datum'| translate:['reporting.timeframe-matching.date',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let sumRow"> {{sumRow.date}} </td>
          </ng-container>

          <ng-container matColumnDef="carrier">
            <th mat-header-cell *matHeaderCellDef>
              {{'Spedition'| translate:['tmc-yard.entity.transport.carrier',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let sumRow" class="action" (click)="setSelectedCarrier(sumRow.carrier)">
              {{sumRow.carrier}} </td>
          </ng-container>

          <ng-container matColumnDef="total-transports">
            <th mat-header-cell *matHeaderCellDef>
              {{'Transporte'| translate:['reporting.timeframe-matching.transports',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.totalTransports}}</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="with-timeslot-booking">
            <th mat-header-cell *matHeaderCellDef>
              {{'mit Zeitfenster'| translate:['reporting.timeframe-matching.withTimeSlot',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.withTimeslotBooking}}</div>
                <div class="value-percentage">{{sumRow.percentageWithTimeslotBooking | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="early">
            <th mat-header-cell *matHeaderCellDef>
              {{'verfrüht'| translate:['reporting.timeframe-matching.early',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.countEarly}}</div>
                <div class="value-percentage">{{sumRow.percentageEarly | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="in-time">
            <th mat-header-cell *matHeaderCellDef>
              {{'pünktlich'| translate:['reporting.timeframe-matching.inTime',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.countInTime}}</div>
                <div class="value-percentage">{{sumRow.percentageInTime | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="delayed">
            <th mat-header-cell *matHeaderCellDef>
              {{'verspätet'| translate:['reporting.timeframe-matching.delayed',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.countDelayed}}</div>
                <div class="value-percentage">{{sumRow.percentageDelayed | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="late">
            <th mat-header-cell *matHeaderCellDef>
              {{'stark verspätet'| translate:['reporting.timeframe-matching.late',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.countLate}}</div>
                <div class="value-percentage">{{sumRow.percentageLate | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="not-arrived">
            <th mat-header-cell *matHeaderCellDef>
              {{'nicht angekommen'| translate:['reporting.timeframe-matching.notArrived',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.countNotArrived}}</div>
                <div class="value-percentage">{{sumRow.percentageNotArrived | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="not-yet-arrived">
            <th mat-header-cell *matHeaderCellDef>
              {{'noch nicht erschienen'| translate:['reporting.timeframe-matching.notYetArrived',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.countNotYetArrived}}</div>
                <div class="value-percentage">{{sumRow.percentageNotYetArrived | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="other">
            <th mat-header-cell *matHeaderCellDef>
              {{'sonstige'| translate:['reporting.timeframe-matching.other',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let sumRow">
              <div class="cell-content">
                <div class="value-count">{{sumRow.countOther}}</div>
                <div class="value-percentage">{{sumRow.percentageOther | number: '1.1-1'}} %</div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
          <tr mat-row *matRowDef="let transport; columns: columnsToDisplay"></tr>
        </table>

      </sc-scroll-pane>
    </sc-content-area>
  </sc-flex-fitting-content>

</sc-flex>
